import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-y', 'IconLetterY', [["path",{"d":"M7 4l5 9l5 -9","key":"svg-0"}],["path",{"d":"M12 13l0 7","key":"svg-1"}]]);